export default function (projectBillingType) {
  function addWorkType(name="") {
    var index = workTypeCount();

    var newHtml = $('#prototype-work-type').html().replace(/__name__/g, index);
    newHtml = $.parseHTML(newHtml);
    $(newHtml).find('input').val(name);

    $('.work-types').append(newHtml);
    $('.work-type').last().find('input').focus();
    toggleEmptyMessage();
  };

  function addWorkRate(workTypeIndex) {
    var $workType = $($('.work-type')[workTypeIndex]);
    if (!$workType) {
      return;
    }
    var index = $workType.find('.work-rate').length;

    var newHtml = $('#prototype-work-rate').html()
        .replace(/__name__/g, workTypeIndex)
        .replace(/__rate_name__/g, index);
    newHtml = $.parseHTML(newHtml);
    $(newHtml).find('select')
      .html($('#prototype-user-select').html());

    $workType.find('.work-rates').append(newHtml);
    $workType.find('select').select2();
  };
  
  var workTypeCount = function() {
    return $('.work-type').length;
  }

  var toggleEmptyMessage = function () {
    var message = $('#empty-message');

    if (workTypeCount() > 0) {
      message.hide();
      return
    }
    message.show();
  }

  var defaultWorkTypes = function() {
    if (workTypeCount() <= 0) {
      switch(projectBillingType) {
      case 2:
        addWorkType('on site');
        addWorkType('remote');
        addWorkType('unbilled');
        break;
      case 3:
        addWorkType('development');
        break;
      default:
        break;
      }
    }
  }

  $('.add-work-type').click(function(e) {
    e.preventDefault();
    addWorkType();
  });

  $(document).on('click', '.money-widget .input-group-prepend', function(e) {
    var $input = $(this).parents('.money-widget').find('.currency');
    var $icon = $(this).parents('.money-widget').find('.currency-icon');
    var currentCurrency = $input.val();
    var newCurrency = currentCurrency === 'USD' ? 'GBP' : 'USD';

    $input.val(newCurrency);
    $icon.removeClass(`fa-gbp fa-usd`)
      .addClass(`fa-${newCurrency.toLowerCase()}`);
  });

  $(document).on('click', '.add-work-rate', function(e) {
    e.preventDefault();
    addWorkRate($(this).data('index'));
  });

  $(document).on('click', '.remove-work-type', function(e) {
    e.preventDefault();
    $(this).parents('.work-type').remove();
    toggleEmptyMessage();
  });

  $(document).on('click', '.remove-work-rate', function(e) {
    e.preventDefault();
    $(this).parents('.work-rate').remove();
  });

  defaultWorkTypes();
  toggleEmptyMessage();
}



// WEBPACK FOOTER //
// ./assets/js/edit-project-work-types.js